const environmentTitleMap = {
    web:'Web',
    ios:'iOS',
    android:'Android',
};

export default environmentTitleMap;